export const BaseDict = {
    MyPulseBets: "My Pulse Bets",
    PlaceBet: "Place Pulse Bet",
    PleaseLoginToPlaceBet: "Please Login",
    PulseBetInterval: "1 min Pulse",
    PulseBetMsgGoal: "Goal",
    PulseBetMsgWin: "You Won {0}!",
    SortedHeading: "1 min Pulse",
    ThirtySecPulse: "30 Sec",
    OneMinPulse: "1 min",
    FiveMinPulse: "5 min",
    TenMinPulse: "10 min",
    BetAgain: "BET AGAIN",
    RepeatBet: "REPEAT BET FOR {0}",
    NoOpenPulseBets: "You do not have any open pulse bets"
};
//# sourceMappingURL=dict.js.map